import Call from '../Call.v2';
import {objToQs} from '../Utils';

const BidderBids = {
    get(filters) {
        return Call(`bidder/bids/?${objToQs(filters)}`);
    },

    getBrowsers(filters) {
        return Call(`bidder/bids/browser?${objToQs(filters)}`);
    },
};

export default BidderBids;



// WEBPACK FOOTER //
// ./src/services/API/components/BidderBids.js